import type { BlockType, ComputedBlockStateUnionType } from '@unifyapps/defs/types/block';
import noop from 'lodash/noop';
import { useRegistryContext } from '../../RegistryProvider';
import type { ComputeContextType } from '../../../hooks/computeContext/BuildComputeContext';

const useGetFallbackNode = ({
  fallback,
  isSuspended,
}: {
  fallback: BlockType['fallback'];
  isSuspended?: boolean;
}) => {
  const { registry } = useRegistryContext();

  if (!fallback) return { fallbackNode: null };

  const Block = registry.getBlockComponent(fallback.componentType);

  const initialFallbackState = registry.getBlockInitialState(fallback.componentType, {
    component: fallback,
    id: 'fallback',
  });

  const fallbackNode =
    isSuspended && Block && initialFallbackState ? (
      <Block
        block={{
          id: 'fallback',
          component: fallback,
        }}
        blockState={initialFallbackState}
        component={fallback}
        computedBlockState={initialFallbackState as ComputedBlockStateUnionType}
        getGlobalStoreContext={() => ({}) as ComputeContextType}
        registry={registry}
        updateBlockSessionState={noop}
        updateBlockState={noop}
      />
    ) : null;

  return {
    fallbackNode,
  };
};

export default useGetFallbackNode;
